import t from"./setTransition.js";import i from"./transitionStart.js";import n from"./transitionEnd.js";const r={setTransition:t,transitionStart:i,transitionEnd:n};export{r as default};
//# sourceMappingURL=index.js.map
